import React from 'react';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from '../../utils';
/* replace-start */
import './index.less';
/* replace-end */
class Feature25 extends React.PureComponent {
  render() {
    const { ...tagProps } = this.props;
    const { dataSource } = tagProps;
    delete tagProps.dataSource;
    delete tagProps.isMobile;

    return (
      <OverPack {...tagProps} {...dataSource.wrapper}>
        <div {...dataSource.bg}>
          <img src={dataSource.bg.children} alt="" />
        </div>
        <div {...dataSource.page}>
          <div {...dataSource.content}>
            <div {...dataSource.content.box}>
              {
              dataSource.content.box.children.map(getChildrenToRender)
            }
            </div>
          </div>
        </div>
      </OverPack>
    );
  }
}
export default Feature25;
